import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { AttachmentUploadResponse, AttachmentDeleteRequest } from '@models/attachment.model'
import { OrderFilesProfileQueryResponse } from '@models/order-files.model'

/**
 * Service for handling file upload operations,
 * including requesting presigned URLs for direct S3 uploads.
 */
@Injectable({
  providedIn: 'root'
})
export class DecomUploadService {
  private apiUrl = environment.api_url;

  constructor(private http: HttpClient) { }

  /**
   * Requests presigned upload URLs for the provided files associated with a profile.
   * 
   * @param uploadData An object containing the profile ID and an array of files to upload
   * @param uploadData.profile_id The unique identifier of the profile
   * @param uploadData.files An array of file details to upload 
   * @returns Observable emitting an object containing an array of attachment paths (presigned URLs)
   */
  getUploadUrl(uploadData: {
    profile_id: string,
    files: Array<{ filename: string, content_type: string, file_size_mb: number }>
  }): Observable<{ attachment_path: string[] }> {
    const token: string | null = localStorage.getItem('token');
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': ` ${token}`  // if needed
    });
    const fetchApi: string = `${this.apiUrl}/attachment/request-upload-url`;

    return this.http.post<{ attachment_path: string[] }>(fetchApi, uploadData, { headers });
  }

  /**
   * Fetches a paginated list of customers from the API.
   * 
   * @param profile_id The unique identifier of the profile_id whose details need to be fetched.  
   * @returns Observable emitting the API response containing customer profiles
   */
  getFileListByProfileId(profile_id: string): Observable<OrderFilesProfileQueryResponse> {
    const token: string | null = localStorage.getItem('token');
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': ` ${token}`  // if needed
    });

    const fetchApi: string = `${environment.api_url}/order-files/by-profile-id`;
    const params: HttpParams = new HttpParams()
      .set('profile_id', profile_id)

    return this.http.get<OrderFilesProfileQueryResponse>(fetchApi, { params, headers });

  }

  /**
   * Fetches a paginated list of customers from the API.
   * 
   * @param delete_file delete file base on get data  
   * @returns Observable emitting the API response containing customer profiles
   */
  deleteUploadFile(delete_file: AttachmentDeleteRequest): Observable<AttachmentUploadResponse> {
    const token: string | null = localStorage.getItem('token');
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': ` ${token}`  // if needed
    });

    const fetchApi: string = `${environment.api_url}/attachment/delete`;
    return this.http.post<AttachmentUploadResponse>(fetchApi, delete_file, { headers });

  }


}
